// The UniversHeal leaf — a vesica-shaped seed-leaf, the core brand mark.
export const LeafMark = ({ className = "w-5 h-5" }) => (
    <svg
        viewBox="0 0 32 32"
        fill="none"
        className={className}
        aria-hidden="true"
        focusable="false"
    >
        <path
            d="M16 3.5C24 9.5 26.5 16.5 16 28.5C5.5 16.5 8 9.5 16 3.5Z"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
        />
        <path
            d="M16 9.5V23"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
        />
    </svg>
);

export const LeafDivider = ({ className = "text-natural" }) => (
    <span className={`inline-flex items-center ${className}`} aria-hidden="true">
        <LeafMark className="w-3.5 h-3.5" />
    </span>
);
